import {
    CartStep2InsuranceInterface,
    CartStep2InsuranceResponseInterface,
} from '@/core/domain/cart-step2/models/cart-step2-insurance.model';
import { CartStep2InsuranceRepository } from '@/core/domain/cart-step2/repositories/cart-step2-insurance.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CartStep2InsuranceImplRepository extends CartStep2InsuranceRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override sendCartStep2Insurance(
        array: CartStep2InsuranceInterface,
    ): Observable<CartStep2InsuranceResponseInterface> {
        return this.httpClient.post<CartStep2InsuranceResponseInterface>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.cartInsurance,
            ].join('/'),
            array,
        );
    }
}
